import { Suspense, lazy } from 'react';
import { ShipmentDetailProps } from './ShipmentDetail';

const Component = lazy(() => import("./ShipmentDetail"));

function ShipmentDetail(props: ShipmentDetailProps) {
    return (
        <div>
            <Suspense fallback={<div>loading...</div>}>
                <Component getHeaders={props.getHeaders} />
            </Suspense>
        </div>);

}

export default ShipmentDetail; 
